import { Demande } from './demande';

export class Upload {
    crecheIds: number[];
    demande: Demande;

    constructor() {
        this.crecheIds = [];
    }
}